import { createSlice } from "@reduxjs/toolkit";

export const isUploadLaterSlice = createSlice({
    name: "isUploadLater",
    initialState: false,
    reducers: {
    setUploadLater: (state, action) => action.payload,
    },
});

export const { setUploadLater } = isUploadLaterSlice.actions;

export default isUploadLaterSlice.reducer;
